exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".queue-item__detail--notes{padding-left:1em !important}", ""]);

